import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { LOGOS } from "@/brand";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[#0A0A0B] concrete-grain px-6 text-center" data-testid="payment-cancel-page">
      <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }} className="flex flex-col items-center">
        <img src={LOGOS.monogram} alt="" className="logo-blend h-14 w-auto mb-8" />
        <h1 className="font-display text-4xl sm:text-6xl chrome-text uppercase">The Vault Stayed Shut</h1>
        <p className="mt-4 max-w-md text-xs leading-loose text-zinc-500 uppercase tracking-[0.2em]">
          Checkout was cancelled. Your cart is untouched — the crown waits for no one, but your items do.
        </p>
        <Link
          data-testid="payment-cancel-return"
          to="/"
          className="mt-12 border border-zinc-400 bg-zinc-100 px-10 py-4 text-xs font-bold tracking-[0.35em] text-zinc-950 uppercase transition-colors duration-300 hover:bg-transparent hover:text-zinc-100"
        >
          Back to the Shop
        </Link>
      </motion.div>
    </div>
  );
}
